import BaseCollection from "lib/collection";
import Filter from "models/filter";

export default BaseCollection.extend({
    model: Filter,
    mainIndex: "__key",
    session: {
        type: {
            type: "string",
            values: ["order", "item", "company", "smart-group", "contacts"],
            default: "order",
        },
    },
    indexes: ["__key"],
    url: function (scope) {
        return this.catalog
            ? `/api/v3.1/catalog/${this.catalog}/filters`
            : `/api/v3.0/brand/${scope.brand._id}/filters/${this.type}`;
    },
    parse: function (response) {
        return response?.hasOwnProperty("dynamic_filter") ? response.data : response;
    },
});
